module.exports = __webpack_public_path__ + "media/images/360/sleep_paralysis_night_mare-b828fda96d46c6a66f8d77ebfe959dcc.jpg";